<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    v-bind="attrs"
    v-on="$listeners"
    :fullscreen="isMobile"
    scrollable
  >
    <slot />
  </v-dialog>
</template>

<script>
export default {
  name: 'popup2',
  props: {
    value: {
      type: [Boolean],
      default: false
    }
  },
  computed: {
    attrs() {
      const attrs = this.$attrs;
      const { value, input } = attrs;
      return attrs;
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  }
};
</script>
